<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path d="M10.1346 10.0647C9.82226 9.75245 9.82239 9.24629 10.1346 8.93387L15.2664 3.80008L11.4012 3.79813C10.9595 3.79798 10.6016 3.44084 10.6014 2.9993C10.6015 2.55769 10.9595 2.19965 11.4012 2.1995L17.2 2.19852C17.4122 2.19852 17.6164 2.28386 17.7664 2.43387C17.9162 2.58382 18.0008 2.78736 18.0008 2.9993L17.9998 8.79715C17.9996 9.23874 17.6418 9.59598 17.2 9.59598C16.7585 9.59578 16.4004 9.23862 16.4002 8.79715V4.92997L11.2654 10.0647C10.953 10.3768 10.447 10.3769 10.1346 10.0647Z" fill="currentColor" />
    <path
      d="M17.2002 13.2298V15.999C17.2002 16.5513 16.7525 16.999 16.2002 16.999H4.2002C3.64791 16.999 3.2002 16.5513 3.2002 15.999V3.99902C3.2002 3.44674 3.64791 2.99902 4.2002 2.99902H6.96943"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
